























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";
import { SimpleTextLayer } from "@/model/document2/page/surface/design/layer/simpleTextLayer";
import SimpleTextLayerDrawerA from "./simpleTextLayerDrawerA.vue";
import SimpleTextLayerDrawerB from "./simpleTextLayerDrawerB.vue";

@Component({
  components: {
    SimpleTextLayerDrawerA,
    SimpleTextLayerDrawerB
  }
})
export default class SimpleTextLayerDrawer extends Vue {
  @Prop() private layer!: SimpleTextLayer;
  @Prop() private scale!: number;
  @Prop() private offsetX!: number;
  @Prop() private offsetY!: number;
  @Prop() private isRendering!: boolean;
  @Prop() private isRenderingOnClient!: boolean;
  @Prop({ default: false }) private isInEditor!: boolean;

  private get isDrawerB_Visible() {
    // MSフォントは文字ごとに位置を決定する描画を行う
    let fontId = this.layer.baseTextInfo.fontId;
    return (
      fontId == "MS-PGothic" || 
      fontId == "MS-PMincho" || 
      fontId == "MS-UIGothic" || 
      fontId == "MS-Gothic" || 
      fontId == "MS-Mincho"
      );
  }
}
